import * as base from "./base";
import * as derived from "./derived";

/**
 * Comment thread selectors namespace
 *
 * Usage:
 * - comments.byUid('uid')(state) - Get comment thread by UID
 * - comments.titleByUid('uid')(state) - Get comment thread title
 * - comments.unresolvedPcbCount(state) - Count unresolved PCB comments
 * - comments.pcb2dUids(state) - Get PCB 2D comment thread UIDs
 */
export const comments = {
    ...base,
    ...derived,
} as const;

export type CommentsSelectors = typeof comments;
